// import React, { useEffect } from "react";

// import { Button, Checkbox, Form, Grid, Input, theme, Typography } from "antd";

// import { LockOutlined, MailOutlined } from "@ant-design/icons";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import { useAuth } from "../../context/Authcontext";
// import { loginUserApi } from "../../services/users";

// const { useToken } = theme;
// const { useBreakpoint } = Grid;
// const { Text, Title, Link } = Typography;

// export default function Login() {
//   const { token } = useToken();
//   const screens = useBreakpoint();
//   const navigate = useNavigate();
//   const { login, user,currentRole ,token:userToken} = useAuth();

//  useEffect(() => {
//   if (user ) {
//     console.log(user,"user before")
//     navigateRoute();
//   }
// }, [user]);
//   const navigateRoute = async ()=>{
// if (!user ) return navigate("/login");
// console.log(user,user?.role?.name,"user login back")
// if (user?.role === "superAdmin"||'Super Admin') {
//       return navigate("/", { replace: true });
//     } else if (user?.role === "tenantAdmin") {
//       return navigate(`/tenant/${user.tenant}`, { replace: true });
//     } else if (user?.role === "companyAdmin") {
//       return navigate(`/company/${user?.company}`, { replace: true });
//     } else  if (user?.role === "employee"){
//       // Default fallback route
//       // navigate("/login", { replace: true });
//       return 
//     }
//   }
//   const onFinish = async (values) => {
//     console.log("Received values of form: ", values);
//     let res = await loginUserApi(values)

    
//     if(res?.error ||res===null){
//         toast.error(res?.message||'try again!')
//         return 
//     }
//     if(res?.token){
//         login(res?.token,res?.user);
//         toast.success("login sucessfull!");
//         // navigate("/");
         
//     console.log(res,currentRole,"res")
//       let {user} = res
//      if (user?.role === "superAdmin") {
//       navigate("/", { replace: true });
//     } else if (user?.role === "tenantAdmin") {
//       navigate(`/tenant/${user.tenant?._id}`, { replace: true });
//     } else if (user?.role === "companyAdmin") {
//       navigate(`/company/${user.company?._id}`, { replace: true });
//     } else  if (user?.role === "employee"){
//       // Default fallback route
//       navigate("/login", { replace: true });
//     }
//     }


    
//   };

//   const styles = {
//     container: {
//       margin: "0 auto",
//       padding: screens.md
//         ? `${token.paddingXL}px`
//         : `${token.sizeXXL}px ${token.padding}px`,
//       width: "380px",
//     },
//     footer: {
//       marginTop: token.marginLG,
//       textAlign: "center",
//       width: "100%",
//     },
//     forgotPassword: {
//       float: "right",
//     },
//     header: {
//       marginBottom: token.marginXL,
//     },
//     section: {
//       alignItems: "center",
//       backgroundColor: token.colorBgContainer,
//       display: "flex",
//       height: screens.sm ? "100vh" : "auto",
//       padding: screens.md ? `${token.sizeXXL}px 0px` : "0px",
//     },
//     text: {
//       color: token.colorTextSecondary,
//     },
//     title: {
//       fontSize: screens.md ? token.fontSizeHeading2 : token.fontSizeHeading3,
//     },
//   };

//   return (
//     <section style={styles.section}>
//       <div style={styles.container}>
//         <div style={styles.header}>
//           <Title style={styles.title}>Sign in</Title>
//           <Text style={styles.text}>
//             Welcome back ! Please enter your details below to sign in.
//           </Text>
//         </div>
//         <Form
//           name="normal_login"
//           initialValues={{
//             remember: true,
//           }}
//           onFinish={onFinish}
//           layout="vertical"
//           requiredMark="optional"
//         >
//           <Form.Item
//             name="email"
//             rules={[
//               {
//                 type: "email",
//                 required: true,
//                 message: "Please input your UserId!",
//               },
//             ]}
//           >
//             <Input prefix={<MailOutlined />} placeholder="userId" />
//           </Form.Item>
//           <Form.Item
//             name="password"
//             rules={[
//               {
//                 required: true,
//                 message: "Please input your Password!",
//               },
//             ]}
//           >
//             <Input.Password
//               prefix={<LockOutlined />}
//               type="password"
//               placeholder="Password"
//             />
//           </Form.Item>
//           <Form.Item>
//             <Form.Item name="remember" valuePropName="checked" noStyle>
//               <Checkbox>Remember me</Checkbox>
//             </Form.Item>
//             <a style={styles.forgotPassword} href="">
//               Forgot password?
//             </a>
//           </Form.Item>
//           <Form.Item style={{ marginBottom: "0px" }}>
//             <Button block="true" type="primary" htmlType="submit">
//               Log in
//             </Button>
//             <div style={styles.footer}>
//               <Text style={styles.text}>Don't have an account?</Text>{" "}
//               <Link href="">Sign up now</Link>
//             </div>
//           </Form.Item>
//         </Form>
//       </div>
//     </section>
//   );
// }


import React, { useEffect, useRef } from "react";
import { Button, Checkbox, Form, Grid, Input, theme, Typography } from "antd";
import { LockOutlined, MailOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useAuth } from "../../context/Authcontext";
import { loginUserApi } from "../../services/users";

const { useToken } = theme;
const { useBreakpoint } = Grid;
const { Text, Title, Link } = Typography;

export default function Login() {
  const { token } = useToken();
  const screens = useBreakpoint();
  const navigate = useNavigate();
  const { login, user, currentRole, token: userToken, loading } = useAuth();
  const hasNavigated = useRef(false);

  useEffect(() => {
    // Wait for auth context to finish loading
    if (loading) return;
    
    // Only navigate once and if user exists
    if (user && !hasNavigated.current) {
      hasNavigated.current = true;
      navigateRoute();
    }
  }, [user, loading]);

  const navigateRoute = () => {
    if (!user) return navigate("/login");
    
    console.log(user, user?.role, "user login back");
    
    // Use the role from currentRole (which comes from getUserRoles API)
    const userRole = currentRole?.name || user?.role;
    
    if (userRole === "superAdmin" || userRole === "Super Admin") {
      return navigate("/", { replace: true });
    } else if (userRole === "tenantAdmin") {
      return navigate(`/tenant/${user.tenant?._id || user.tenant}`, { replace: true });
    } else if (userRole === "companyAdmin") {
      return navigate(`/company/${user.company?._id || user.company}`, { replace: true });
    } else if (userRole === "employee") {
      // For employees, you might want to navigate to a dashboard or stay on login
      return navigate("/employee-dashboard", { replace: true }); // or return without navigation
    }
  };

  const onFinish = async (values) => {
    try {
      console.log("Received values of form: ", values);
      let res = await loginUserApi(values);

      if (res?.error || res === null) {
        toast.error(res?.message || 'Try again!');
        return;
      }

      if (res?.token) {
        // Reset navigation flag for new login
        hasNavigated.current = false;
        
        await login(res?.token, res?.user);
        toast.success("Login successful!");

        // The navigation will be handled by the useEffect after login updates the user state
      }
    } catch (error) {
      console.error("Login error:", error);
      toast.error("An error occurred during login");
    }
  };

  const styles = {
    container: {
      margin: "0 auto",
      padding: screens.md
        ? `${token.paddingXL}px`
        : `${token.sizeXXL}px ${token.padding}px`,
      width: "380px",
    },
    footer: {
      marginTop: token.marginLG,
      textAlign: "center",
      width: "100%",
    },
    forgotPassword: {
      float: "right",
    },
    header: {
      marginBottom: token.marginXL,
    },
    section: {
      alignItems: "center",
      backgroundColor: token.colorBgContainer,
      display: "flex",
      height: screens.sm ? "100vh" : "auto",
      padding: screens.md ? `${token.sizeXXL}px 0px` : "0px",
    },
    text: {
      color: token.colorTextSecondary,
    },
    title: {
      fontSize: screens.md ? token.fontSizeHeading2 : token.fontSizeHeading3,
    },
  };

  // Show loading state while auth is initializing
  if (loading) {
    return (
      <section style={styles.section}>
        <div style={styles.container}>
          <div style={styles.header}>
            <Title style={styles.title}>Loading...</Title>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section style={styles.section}>
      <div style={styles.container}>
        <div style={styles.header}>
          <Title style={styles.title}>Sign in</Title>
          <Text style={styles.text}>
            Welcome back! Please enter your details below to sign in.
          </Text>
        </div>
        <Form
          name="normal_login"
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
          layout="vertical"
          requiredMark="optional"
        >
          <Form.Item
            name="email"
            rules={[
              {
                type: "email",
                required: true,
                message: "Please input your email!",
              },
            ]}
          >
            <Input prefix={<MailOutlined />} placeholder="Email" />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[
              {
                required: true,
                message: "Please input your Password!",
              },
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              type="password"
              placeholder="Password"
            />
          </Form.Item>
          <Form.Item>
            <Form.Item name="remember" valuePropName="checked" noStyle>
              <Checkbox>Remember me</Checkbox>
            </Form.Item>
            {/* <a style={styles.forgotPassword} href="">
              Forgot password?
            </a> */}
          </Form.Item>
          <Form.Item style={{ marginBottom: "0px" }}>
            <Button block="true" type="primary" htmlType="submit">
              Log in
            </Button>
            {/* <div style={styles.footer}>
              <Text style={styles.text}>Don't have an account?</Text>{" "}
              <Link href="">Sign up now</Link>
            </div> */}
          </Form.Item>
        </Form>
      </div>
    </section>
  );
}